module.exports = __webpack_public_path__ + "static/img/third1_1_active.ab606d25.png";